import { useState, useContext, useEffect } from "react";
import { BarbershopContext } from "../../providers/useProvider";
import AlertMessage from "../../components/AlertMessage";
import useForgetPassword from "../../hooks/useForgetPassword";
import "./login.css";
const ForgetPassword = () => {
  const { handleForgetPassword, message, setShowMessage, showMessage, config } =
    useForgetPassword();
  const [email, seEmail] = useState("");

  const handleChange = (e) => {
    seEmail(e.target.value);
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    await handleForgetPassword(email);
  };

  return (
    <div className="d-flex justify-content-center h-100">
      <div className="d-flex align-items-center">
        <div className="login-card row g-0 shadow-lg">
          <div className="row g-0">
            <div className="col-md-6 image-side">
              <div>
                <h2>Find your sweet home</h2>
                <p>
                  Schedule visits in just a few clicks.
                  <br />
                  Your dream property awaits.
                </p>
              </div>
            </div>

            <div className="col-md-6 d-flex align-items-center justify-content-center form-side">
              <div className="w-100">
                <h4 className="login-title mb-2 text-color">
                  Welcome Back to {config?.brandName}!
                </h4>
                <p className="text-muted login-subtitle mb-4">
                  Forgot your password?
                </p>
                <p>
                  {showMessage && (
                    <AlertMessage
                      key={message.text}
                      setVisible={setShowMessage}
                      message={message.text}
                      type={message.type}
                      duration={4000}
                    />
                  )}
                </p>
                <form onSubmit={handleSubmit}>
                  <div className="mb-3">
                    <label for="email" className="form-label small text-muted">
                      Email
                    </label>
                    <input
                      id="email"
                      name="email"
                      type="email"
                      className="form-control login-input"
                      value={email}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <div className="d-flex justify-content-end">
                    <button type="submit" className="btn login-btn w-100 mb-3">
                      Next
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgetPassword;
